import {useEffect, useState} from "react";
import {Box, FormControl, Grid, InputLabel, Select, TextField} from "@material-ui/core";
import {withStyles} from "@material-ui/core/styles";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import * as React from "react";
import Dialog from "@material-ui/core/Dialog";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthState} from "../../context/AuthContext";
import {FeedbackService} from "../feedbacks/FeedbackService";
import moment from "jalali-moment";

const FeedbackInfo = ({openModal, handleClose, selectedItemId, needRefresh}) => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()
    const {token, fundID} = useAuthState()

    const service = new FeedbackService(fundID, token, snackbar, loading)


    const [title, setTitle] = useState("");
    const [fullName, setFullName] = useState("")
    const [group, setGroup] = useState("");
    const [date, setDate] = useState("");
    const [status, setStatus] = useState("AWAITING_FOR_REVIEW")
    const [description, setDescription] = useState("")


    useEffect(() => {
        if (openModal && selectedItemId >= 0) {
            getFeedbackInfo()
        }
    }, [openModal])

    function getFeedbackInfo() {
        loading(setLoadingStateDispatch(true))

        service.getFeedbackInfo(fundID, selectedItemId)
            .then(response => {
                setTitle(response.title)
                setDescription(response.description)
                setGroup(response.senderGroupName)
                setFullName(`${response.senderFirstName} ${response.senderLastName}`)
                setDate(moment(response.sendAt, 'YYYY-MM-DD').locale('fa').format('YYYY/MM/DD'))
                setStatus(response.status)

                loading(setLoadingStateDispatch(false))
            }).catch(reason => {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در دریافت جزئیات انتقاد و پیشنهاد"))
            loading(setLoadingStateDispatch(false))
        })
    }


    // dialog-start
    const styles = (theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(2),
        },
        closeButton: {
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: theme.palette.grey[500],
        },
    });

    const DialogTitle = withStyles(styles)((props) => {
        const {children, classes, onClose, ...other} = props;
        return (
            <MuiDialogTitle disableTypography className={classes.root} {...other}>
                <Typography variant="h6">{children}</Typography>
                {onClose ? (
                    <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon/>
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    });

    const DialogActions = withStyles((theme) => ({
        root: {
            margin: 0,
            padding: theme.spacing(1),
        },
    }))(MuiDialogActions);

    // dialog-end

    function handleChangeFeedbackState() {
        needRefresh(true)
        service.changeFeedbackState(fundID, selectedItemId, status)
    }

    return (
        <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={openModal}
                id="PersonalizedMediumDialog">
            <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                جزئیات انتقاد و پیشنهاد
            </DialogTitle>
            <section style={{padding: "1rem", flexGrow: "1"}}>
                <Box className="d-flex flex-grow-1 w-100" sm={12}>
                    <Grid className='d-flex flex-row flex-wrap flex-grow-1 w-100' sm={12} style={{marginTop: '1rem'}}>
                        <Grid sm={6} md={6} lg={6} xl={3} className="w-100 p-2">
                            <TextField
                                className="w-100"
                                id="outlined-basic"
                                disabled={true}
                                label="عنوان"
                                variant="outlined"
                                value={title}
                            />
                        </Grid>
                        <Grid sm={6} md={6} lg={6} xl={3} className="w-100 p-2">
                            <TextField
                                className="w-100"
                                id="outlined-basic"
                                disabled={true}
                                label="نام و نام خانوادگی"
                                variant="outlined"
                                value={fullName}
                            />
                        </Grid>
                        <Grid sm={6} md={6} lg={6} xl={3} className="w-100 p-2">
                            <TextField
                                className="w-100"
                                id="outlined-basic"
                                disabled={true}
                                label="گروه"
                                variant="outlined"
                                value={group}
                            />
                        </Grid>
                        <Grid sm={6} md={6} lg={6} xl={3} className="w-100 p-2">
                            <TextField
                                className="w-100"
                                id="outlined-basic"
                                disabled={true}
                                label="تاریخ"
                                variant="outlined"
                                value={date}
                            />
                        </Grid>
                        <Grid sm={12} md={12} lg={12} xl={12} className='p-2 w-100'>
                            <FormControl variant="outlined" className="w-100">
                                <InputLabel htmlFor="filled-age-native-simple">وضعیت</InputLabel>
                                <Select value={status} onChange={e => {
                                    setStatus(e.target.value)
                                }} label="وضعیت">
                                    <option className="bg_deActive_state px-2 py-1" value={"AWAITING_FOR_REVIEW"}>در
                                        درست برسی
                                    </option>
                                    <option className="bg_active_state px-2 py-1" value={"REVIEWED"}>بررسی شده</option>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid sm={12} md={12} lg={12} xl={12} className='p-2 w-100'>
                            <TextField
                                className="w-100"
                                label="توضیحات"
                                disabled={true}
                                multiline
                                rows={6}
                                variant="outlined"
                                value={description}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </section>
            <DialogActions>
                <button className="btn-confirm" onClick={handleChangeFeedbackState}>
                    بروزرسانی
                </button>
            </DialogActions>
        </Dialog>

    )
};

export default FeedbackInfo

//
// <section className="modalBackground">
//     <div className="modalContainer">
//     <div className="titleCloseBtn">
//     <span className="title">جزئیات انتقاد و پیشنهاد</span>
// <button onClick={() => closeModal(false, needRefresh)}>&times;</button>
// </div>
// <Box className='flex-grow-1'>
// <Grid sm={12} style={{marginTop: '1rem', justifyContent: 'space-between'}}
// className='d-flex flex-row flex-wrap flex-grow-1'>
//
//     <Grid sm={12} md={6} lg={3} xl={3} className='modalTextFieldContainer'>
//     <TextField
// value={name}
// onChange={e => {
//     setName(e.target.value)
// }}
// className='w-100' variant="outlined" label="عنوان"/>
//     </Grid>
//
// <Grid sm={12} md={6} lg={3} xl={3} className='modalTextFieldContainer'>
//     <TextField
//         className='w-100'
//         variant="outlined"
//         label="نام و نام خانوادگی"
//         value={orators}
//         onChange={e => {
//             setOrators(e.target.value)
//         }}
//     />
// </Grid>
// <Grid sm={12} md={6} lg={3} xl={3} className='modalTextFieldContainer'>
//     <TextField
//         value={location}
//         onChange={e => {
//             setLocation(e.target.value)
//         }} className='w-100' variant="outlined" label="گروه"/>
// </Grid>
// <Grid sm={12} md={6} lg={3} xl={3} className='modalTextFieldContainer'>
//     <TextField
//         value={location}
//         onChange={e => {
//             setLocation(e.target.value)
//         }} className='w-100' variant="outlined" label="تاریخ"/>
// </Grid>
//
// <Grid sm={12} md={12} lg={12} xl={12} className='modalTextFieldContainer'>
//     <TextField
//         value={location}
//         onChange={e => {
//             setLocation(e.target.value)
//         }} className='w-100' variant="outlined" label="آدرس"/>
// </Grid>
//
// <Grid sm={12} md={12} lg={12} xl={12} className='modalTextFieldContainer'>
//     <label id='residenceStatus' className="toggle-switch-content">
//         <span className="toggle-title">وضعیت (بررسی شده)</span>
//         <label className="switch" htmlFor="MainCategory">
//             <input
//                 type="checkbox"
//                 id="residenceStatus"
//                 checked={enabledStatus}
//                 onChange={e => {
//                     setEnabledStatus(e.target.checked)
//                 }}
//             />
//             <span className="toggle round"/>
//         </label>
//
//     </label>
// </Grid>
//
// </Grid>
// </Box>
// <Box className='d-flex flex-row' sx={{alignContent: 'end', justifyContent: "end", marginTop: "1rem"}}>
// <Button onClick={() => {
//     saveInfo()
// }}>
// {selectedItemId>=0 ?"بروزرسانی":"افزودن عضو جدید"}
// </Button>
// </Box>
// </div>
// </section>